import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TableRow,
  Typography,
  TextField,
  InputAdornment,
  TablePagination,
} from "@material-ui/core";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { Search } from "react-feather";
import { useParams } from "react-router-dom";
import Notify from "src/notification/Notify";
import IsMountedRef from "src/utils/IsMountedRef";

const InventoryLaboratory = () => {
  const mounted = IsMountedRef();
  const [list, setList] = useState({ data: [], ready: false });
  const [search, setSearch] = useState("");
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [page, setPage] = React.useState(0);

  let total = 0;
  const { management_id } = useParams();

  const handleChangePage = (event, newPage) => {
    event.persist();
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value));
    setPage(0);
  };

  const getLaboratoryInventory = React.useCallback(async () => {
    let response = await axios.get("accounting/branch/inventory/laboratory", {
      params: {
        management_id: management_id,
      },
    });

    const data = response.data;
    if (mounted.current) {
      setList({ data, ready: true });
    }
  }, [mounted, management_id]);

  const calculateTotal = (_qty_remaining, _srp) => {
    let x = _qty_remaining * _srp;
    total += x;
    return Notify.convertToNumber(x);
  };

  useEffect(() => {
    getLaboratoryInventory();
  }, [getLaboratoryInventory]);

  const searchable = list.data.filter((data) => {
    return data.item.toLowerCase().indexOf(search.trim().toLowerCase()) !== -1;
  });

  return (
    <Paper>
      <Box p={2}>
        <Box display="flex">
          <Box flexGrow={1}>
            <Typography variant="h6" color="textSecondary">
              Laboratory Inventory
            </Typography>
          </Box>
          <Box>
            <TextField
              label="Search item"
              variant="outlined"
              fullWidth
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              InputProps={{
                endAdornment: (
                  <InputAdornment>
                    <Search />
                  </InputAdornment>
                ),
              }}
            />
          </Box>
        </Box>

        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell> Item Id </TableCell>
                <TableCell> Product </TableCell>
                <TableCell> Supplier </TableCell>
                <TableCell> Msrp </TableCell>
                <TableCell> In Qty </TableCell>
                <TableCell> Out Qty </TableCell>
                <TableCell> Rem. Qty </TableCell>
                <TableCell> Total </TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {list.ready ? (
                searchable.length > 0 ? (
                  searchable
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((data, index) => (
                      <TableRow key={index}>
                        <TableCell> {data.item_id} </TableCell>
                        <TableCell> {data.item} </TableCell>
                        <TableCell> {data.supplier} </TableCell>
                        <TableCell align="right"> {data.msrp} </TableCell>
                        <TableCell align="right"> {data._qty_in} </TableCell>
                        <TableCell align="right"> {data._qty_out} </TableCell>
                        <TableCell align="right">
                          {data._qty_remaining}
                        </TableCell>
                        <TableCell align="right">
                          {calculateTotal(data._qty_remaining, data.msrp)}
                        </TableCell>
                      </TableRow>
                    ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={8}>
                      <Typography color="secondary">
                        No record found.
                      </Typography>
                    </TableCell>
                  </TableRow>
                )
              ) : (
                <TableRow>
                  <TableCell colSpan={8}>
                    <Typography color="primary">
                      loading, please wait...
                    </Typography>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
            <TableFooter>
              <TableRow>
                <TableCell colSpan={6}></TableCell>
                <TableCell> Total: </TableCell>
                <TableCell align="right">
                  {Notify.convertToNumber(total)}
                </TableCell>
              </TableRow>
            </TableFooter>
          </Table>

          <TablePagination
            component="div"
            count={searchable.length}
            rowsPerPageOptions={[10, 50, 100]}
            page={page}
            onChangePage={handleChangePage}
            rowsPerPage={rowsPerPage}
            onChangeRowsPerPage={handleChangeRowsPerPage}
            labelRowsPerPage="List"
          />
        </TableContainer>
      </Box>
    </Paper>
  );
};

export default InventoryLaboratory;
